import { Tier } from "@/types";
import { LucideIcon } from "lucide-react";
import { Target, Star, Briefcase, Rocket, Crown, Trophy } from "lucide-react";

// Tier icon mapping
export const TIER_ICONS: Record<string, LucideIcon> = {
  'rookie': Target,
  'rising': Star,
  'professional': Briefcase,
  'expert': Rocket,
  'master': Crown,
  'champion': Trophy,
};

export const TIERS: Tier[] = [
  { id: 'rookie', name: 'Rookie', description: 'Starting tier', imageUrl: '', pointsThreshold: 0, minPoints: 0, maxPoints: 49, color: 'text-muted-foreground', icon: TIER_ICONS['rookie'] },
  { id: 'rising', name: 'Rising Star', description: 'Rising tier', imageUrl: '', pointsThreshold: 50, minPoints: 50, maxPoints: 149, color: 'text-success', icon: TIER_ICONS['rising'] },
  { id: 'professional', name: 'Professional', description: 'Professional tier', imageUrl: '', pointsThreshold: 150, minPoints: 150, maxPoints: 349, color: 'text-primary', icon: TIER_ICONS['professional'] },
  { id: 'expert', name: 'Expert', description: 'Expert tier', imageUrl: '', pointsThreshold: 350, minPoints: 350, maxPoints: 699, color: 'text-energy', icon: TIER_ICONS['expert'] },
  { id: 'master', name: 'Master', description: 'Master tier', imageUrl: '', pointsThreshold: 700, minPoints: 700, maxPoints: 1199, color: 'text-warning', icon: TIER_ICONS['master'] },
  { id: 'champion', name: 'Champion', description: 'Champion tier', imageUrl: '', pointsThreshold: 1200, minPoints: 1200, maxPoints: Infinity, color: 'text-destructive', icon: TIER_ICONS['champion'] },
];

export const getCurrentTier = (totalPoints: number): Tier => {
  return TIERS.find(tier => totalPoints >= tier.minPoints && totalPoints <= tier.maxPoints) || TIERS[0];
};

export const getTiers = (): Tier[] => {
  return TIERS;
};
